import { createStore } from '../lib/store.ts';

// Korte meldingen onderin beeld, met eventueel een ongedaan-maken-knop.

export interface Toast {
  id: number;
  text: string;
  tone: 'info' | 'ok' | 'warn' | 'error';
  action?: { label: string; run: () => void | Promise<void> } | undefined;
  until: number;
}

export const toasts = createStore<Toast[]>([]);
let seq = 0;

export function toast(text: string, opts: { tone?: Toast['tone']; action?: Toast['action']; ms?: number } = {}): number {
  const id = ++seq;
  const ms = opts.ms ?? (opts.action ? 8000 : 4000);
  toasts.set((list) => [...list, { id, text, tone: opts.tone ?? 'info', action: opts.action, until: Date.now() + ms }]);
  setTimeout(() => dismiss(id), ms);
  return id;
}

export function dismiss(id: number): void {
  toasts.set((list) => list.filter((t) => t.id !== id));
}

export function errorToast(e: unknown, prefix?: string): void {
  const message = e instanceof Error ? e.message : String(e);
  toast(prefix ? `${prefix}: ${message}` : message, { tone: 'error', ms: 6000 });
}
